export default {"src":"/_next/static/media/profile_img.b238c572.svg","height":600,"width":600};